export const CART_GET_LOADING = "cart/get/loading"

export const CART_GET_ERROR = "cart/get/error"

export const CART_GET_SUCCESS = "cart/get/success"

export const CART_UPDATE_DATA = "cart/update"

export const CART_REMOVE = "cart/delete"

export const TOTAL_PRICE = "cart/totalPrice"